window.addEventListener('DOMContentLoaded', function () {
    const contactBlocksWithImage = document.querySelectorAll('.contact-block__block-card--has-media');

    if (contactBlocksWithImage && contactBlocksWithImage.length > 0) {
        contactBlocksWithImage.forEach((contactBlock) => {
            if (contactBlock !== null && contactBlock.parentElement !== null) {
                contactBlock.parentElement.classList.add('contact-block--has-media');
            }
        });
    }
});